import analytics from '@banking/ui/workflows/utils/analytics';
import { Action, Screen, ActionType } from '@banking/ui/workflows/debit-card-activation';
import { filter, map } from 'rxjs/operators';
export let EventLogging;
(function (_EventLogging) {
  let Action = /*#__PURE__*/function (Action) {
    Action["Click"] = "Click";
    Action["View"] = "View";
    return Action;
  }({});
  _EventLogging.Action = Action;
  let Page = /*#__PURE__*/function (Page) {
    Page["CardDetails"] = "Card Details";
    Page["CreatePIN"] = "Create PIN";
    Page["CardActivationSuccess"] = "Card Activation Success";
    return Page;
  }({});
  _EventLogging.Page = Page;
  let Target = /*#__PURE__*/function (Target) {
    Target["Continue"] = "Continue";
    return Target;
  }({});
  _EventLogging.Target = Target;
  let CDP;
  (function (_CDP) {
    const eventString = action => `${action} Card Activation`;
    const event = _CDP.event = args => {
      return [eventString(args.action), {
        ...args,
        applet: 'Banking',
        feature: 'Card Activation'
      }];
    };
  })(CDP || (CDP = _EventLogging.CDP || (_EventLogging.CDP = {})));
})(EventLogging || (EventLogging = {}));
const cardDetailsView = updates => updates.pipe(filter(([[before, after], _]) => before.screen !== Screen.DETAILS && after.screen === Screen.DETAILS), map(([[_before, after], _action]) => EventLogging.CDP.event({
  action: EventLogging.Action.View,
  page: EventLogging.Page.CardDetails,
  unitToken: after.unitToken
})));
const cardDetailsClick = updates => updates.pipe(filter(([_, action]) => action.type === ActionType.UserClickVerifyCardDetails), map(([[_before, after], _action]) => EventLogging.CDP.event({
  action: EventLogging.Action.Click,
  page: EventLogging.Page.CardDetails,
  unitToken: after.unitToken,
  target: EventLogging.Target.Continue
})));
const createPinView = updates => updates.pipe(filter(([[before, after], _]) => before.screen !== Screen.CREATE_PIN && after.screen === Screen.CREATE_PIN), map(([[_before, after], _action]) => EventLogging.CDP.event({
  action: EventLogging.Action.View,
  page: EventLogging.Page.CreatePIN,
  unitToken: after.unitToken
})));
const createPinClick = updates => updates.pipe(filter(([_, action]) => action.type === ActionType.UserClickSetPasscode), map(([[_before, after], _action]) => EventLogging.CDP.event({
  action: EventLogging.Action.Click,
  page: EventLogging.Page.CreatePIN,
  unitToken: after.unitToken,
  target: EventLogging.Target.Continue
})));
const cardActivationSuccessView = updates => updates.pipe(filter(([[before, after], _]) => before.screen !== Screen.SUCCESS && after.screen === Screen.SUCCESS), map(([[_before, after], _action]) => EventLogging.CDP.event({
  action: EventLogging.Action.View,
  page: EventLogging.Page.CardActivationSuccess,
  unitToken: after.unitToken
})));
export default analytics([cardDetailsView, cardDetailsClick, createPinView, createPinClick, cardActivationSuccessView]);